<template>
  <v-dialog
    v-model="dialog"
    scrollable
    persistent
    max-width="40%"
    transition="dialog-transition">
    <v-card class="pa-4" v-if="Object.keys(customer).length">
      <v-layout
        column
        fill-height
        height="200px">
        <v-card-title class="mb-3">
          <v-flex xs1>
            <avatar
              :initials="(customer.name || customer.first_name || 'Desconocido').charAt(0).toUpperCase()"
              :size="50"
              background-color="#ff7c64"
              color="#fff"
              class="px-3">
            </avatar>
          </v-flex>
          <v-flex xs10>
            <div class="display-1 text-capitalize ml-4">
              {{ (customer.name || customer.first_name || 'Desconocido').toLowerCase() }}
            </div>
          </v-flex>
          <v-flex xs1>
            <v-btn dark icon @click="dialog = false">
              <v-icon color="black">fas fa-times</v-icon>
            </v-btn>
          </v-flex>
        </v-card-title>
      </v-layout>
      <v-list two-line class="pa-0 pr-4">
        <v-list-tile>
          <v-list-tile-action>
            <v-icon v-if="customer.gender === 'Masculino'">fas fa-mars</v-icon>
            <v-icon class="ml-2" medium v-else>fas fa-venus</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ customer.gender }}</v-list-tile-title>
            <v-list-tile-sub-title>Genero</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider inset></v-divider>
        <v-list-tile>
          <v-list-tile-action>
            <v-icon>fas fa-id-card</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ customer.age || 'Sin especificar' }}</v-list-tile-title>
            <v-list-tile-sub-title>Edad</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <template v-if="customer.customer_phones && customer.customer_phones.length">
          <v-divider inset></v-divider>
          <vue-perfect-scrollbar id="phones-scrollbar">
            <v-list-tile v-for="phone in customer.customer_phones" :key="`phone-${phone.id}`"  @click="edit()">
              <v-list-tile-action>
                <v-icon>phone</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ phone.phone }}</v-list-tile-title>
                <v-list-tile-sub-title>{{ phone.type }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </vue-perfect-scrollbar>
        </template>
      </v-list>
    </v-card>
  </v-dialog>
</template>

<script>
import Avatar from 'vue-avatar';
import EventBus from '@/event-bus';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

export default {
  components: {
    Avatar,
    VuePerfectScrollbar,
  },
  created() {
    EventBus.$on('customerDetailDialog', (customer) => {
      this.customer = customer;
      if (!this.customer.customer_phones) {
        this.axios.get(`customers/${this.customer.id}/phones`).then((response) => {
          this.$set(this.customer, 'customer_phones', response.data);
          EventBus.$emit('updateCustomer', this.customer);
          this.dialog = true;
        }).catch(() => {});
      } else {
        this.dialog = true;
      }
    });
  },
  destroyed() {
    EventBus.$off('customerDetailDialog');
  },
  data() {
    return {
      dialog: false,
      customer: {},
    };
  },
  methods: {
    edit() {
      EventBus.$emit('edit-phones');
    },
  },
};
</script>

<style scoped>
#phones-scrollbar {
  max-height: 225px;
}
#phones-scrollbar .list__tile div:not(.list__tile__action) {
  user-select: text !important;
}
</style>


// WEBPACK FOOTER //
// src/components/chat_center/CustomerDetailDialog.vue